import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { cn, Modal, PrimaryButton, Checkbox, Container, Text } from '@artprov/design-system'

export default function ModalTerminosCondiciones({
  openModal,
  onCloseModal,
  titulo = 'Términos y Condiciones de Uso',
  onAcceptModal,
  content = 'test',
  onDownloadTerm,
}) {
  const [isAccepted, setIsAccepted] = useState(false)

  // Convert className to class for standard HTML rendering
  let htmlContent = content?.replace(/className=/g, 'class=') || ''

  const handleOnAcceptModal = () => {
    if (isAccepted) {
      onAcceptModal()
      onCloseModal()
    }
  }

  // Handle download button click
  const handleDownloadClick = (e) => {
    e.preventDefault()
    if (onDownloadTerm) {
      onDownloadTerm()
    }
  }

  // Add event listener for the download button in the HTML content
  useEffect(() => {
    if (openModal && onDownloadTerm) {
      // Use setTimeout to ensure the HTML is rendered before adding the listener
      const timer = setTimeout(() => {
        const downloadBtn = document.getElementById('download-terms-btn')
        if (downloadBtn) {
          downloadBtn.addEventListener('click', handleDownloadClick)
        }
      }, 100)

      return () => {
        clearTimeout(timer)
        const downloadBtn = document.getElementById('download-terms-btn')
        if (downloadBtn) {
          downloadBtn.removeEventListener('click', handleDownloadClick)
        }
      }
    }
  }, [openModal, onDownloadTerm])

  return (
    <Modal.Container
      height={'auto'}
      open={openModal}
      className={cn('overflow-y-hidden')}
      onClose={onCloseModal}
      scrollX={false}
      closeOnClickOutside={false}
    >
      <Modal.Content width={809} height={600} className="modalContent flex flex-col flex-col">
        <Modal.Header>
          <Modal.Title className="pl-1 text-primary-10">{titulo}</Modal.Title>
        </Modal.Header>
        <div className="border-t "></div>
        <Modal.Body
          className="py-0 w-auto modalBody flex-1 overflow-y-auto"
          classNameScroll="w-auto"
          scrollX={false}
          style={{ backgroundColor: '#lightblue' }}
        >
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </Modal.Body>
        <div className="border-t "></div>
        <Modal.Footer className="flex justify-between items-center  flex-shrink-0">
          <label className="flex items-center gap-2 text-blue-900 body2  text-primary-10 ">
            <input
              type="checkbox"
              checked={isAccepted}
              onChange={(e) => setIsAccepted(e.target.checked)}
              className="w-4 h-4 accent-primary-10 "
            />
            <Text variant="body2 text-primary-10 ">He leído y acepto los Términos y Condiciones</Text>
          </label>
          <PrimaryButton
            className="mx-3"
            size="small"
            onClick={handleOnAcceptModal}
            classNameIcon="text-tertiary-100"
            disabled={!isAccepted}
          >
            Aceptar
          </PrimaryButton>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Container>
  )
}

ModalTerminosCondiciones.propTypes = {
  openModal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  titulo: PropTypes.string,
  onAcceptModal: PropTypes.func.isRequired,
  content: PropTypes.string,
  onDownloadTerm: PropTypes.func,
}
